export default __webpack_public_path__ + "static/media/portada_PedroGarza.5f5693f2.jpg";